<div class="breadcrumbGlobal">
    <a [routerLink]="['/mydashboard']">
        <mat-icon>home</mat-icon>
    </a>
    <mat-icon>chevron_right</mat-icon>
    <a [routerLink]="['/technical-support/technical-support']">
        <span translate>COMMONS.TECHNICAL_SUPPORT</span>
    </a>
    <mat-icon>chevron_right</mat-icon>
    <span translate>COMMONS.IMPROVEMENT_REQUESTS</span>
</div>

<tb-header specificTitle="COMMONS.IMPROVEMENT_REQUESTS" ></tb-header>
<div class="contentGlobal">
    <div class="course-card-container">
        <mat-card *ngIf="improvementRequestSearch" class="course-card course-card--filters">
            <mat-card-header>
                <!--<mat-card-title translate>{{ getFilterTitle() }}</mat-card-title>-->
            </mat-card-header>

            <div [formGroup]="search">
                <div class="filters-container">
                    <mat-form-field appearance="outline">
                        <mat-label translate>COMMONS.COURSEPRODUCT</mat-label>
                        <mat-select formControlName="product">
                            <mat-option value="" translate>Seleziona</mat-option>
                            <mat-option *ngFor="let product of improvementRequestSearch.Products" [value]="product.ProductCode">{{product.Description}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                    <mat-form-field appearance="outline">
                        <mat-label translate>COMMONS.COURSEAREA</mat-label>
                        <mat-select formControlName="functionalArea">
                            <mat-option value="" translate>Seleziona</mat-option>
                            <mat-option *ngFor="let area of improvementRequestSearch.FunctionalAreas" [value]="area.FunctionalAreaCode">{{area.Description}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="filters-container">
                    <mat-form-field appearance="outline">
                        <mat-label translate>COMMONS.STATUS</mat-label>
                        <mat-select formControlName="status">
                            <mat-option value="" translate>Seleziona</mat-option>
                            <mat-option *ngFor="let status of getRequestStatuses()" [value]="getRequestStatusStringValue(status)">{{status}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                    <mat-form-field appearance="outline" style="width: 50%;">
                        <mat-label translate>COMMONS.DATE_RANGE</mat-label>
                        <mat-date-range-input [rangePicker]="picker" class="cp">
                          <input formControlName="init" matStartDate>
                          <input formControlName="end" matEndDate>
                        </mat-date-range-input>
                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-date-range-picker #picker></mat-date-range-picker>
                    </mat-form-field>
                </div>
                <div style="text-align: end;">
                    <button style="align-self: flex-end;" mat-flat-button class="left" color="primary" (click)="searchRequests()">
                        <span translate>COMMONS.SEARCH</span>
                    </button>
                </div>
            </div>

        </mat-card>
        <mat-card *ngIf="!isLoading" class="course-card course-card--courses">

        </mat-card>
    </div>
</div>
<div *ngIf="isLoading">
    <tb-loading></tb-loading>
</div>